import { useDocumentTitle } from "~src/hooks/useDocumentTitle"
import { SafeArea, Image, Button, Dialog, Toast } from "antd-mobile"
import React, { FC, useCallback, useEffect, useState } from "react"
import styles from "./index.module.less"
import { useNavigate } from "react-router-dom"
import { useWXPath } from "~src/hooks/useWXPath"
import { getSuiShenXingAuthCode, getSuiShenXingRewardStatus, getUserBaseInfo } from "~src/service/suishenxing"
import { isWechat, isLvmio, lvmio } from '~src/utils/js-sdk'

const Guide: FC = () => {
  useDocumentTitle('开通碳账户领京东E卡')
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [rewardInfo, setRewardInfo] = useState<{
    hasPrizeQualification: boolean;
    openStatus: boolean
  }>()

  const navigate = useNavigate()
  const wxPath = useWXPath()
  const activityPath = process.env.REACT_APP_SUISHENXING

  useEffect(() => {
    getUserInfo()
    checkIsOpenSuiShenXing()
  }, [])
  const getUserInfo = async () => {
    const { phoneNumber } = await getUserBaseInfo()
    setPhoneNumber(phoneNumber)
  }
  const checkIsOpenSuiShenXing = async () => {
    const res = await getSuiShenXingRewardStatus()
    setRewardInfo(res)
  }
  const onJumpPath = useCallback(async () => {
    if (!phoneNumber) {
      if (isWechat()) {
        wxPath('navigateTo', '/pages/load_bearing/bind_phone/index')
      } else if (isLvmio()) {
        // 绿喵app 未绑定手机号
        await lvmio.callHandler("checkVerifyPhone");
      }
      return
    }
    if (rewardInfo?.openStatus) {
      jumpToSuiShengXing()
    } else {
      navigate('/shuishenxing/auth')
    }
  }, [rewardInfo, phoneNumber])
  const jumpToSuiShengXing = async () => {
    const { code } = await getSuiShenXingAuthCode()
    window.location.href = `${activityPath}?authcode=${code}&clientId=lvmiao0000000001`
  }
  const onPrize = useCallback(async () => {
    if (!phoneNumber) {
      // 未绑定手机号
      if (isWechat()) {
        wxPath('navigateTo', '/pages/load_bearing/bind_phone/index')
      } else if (isLvmio()) {
        // 绿喵app 未绑定手机号
        await lvmio.callHandler("checkVerifyPhone");
      }
    } else if (rewardInfo?.hasPrizeQualification) {
      wxPath('navigateTo', '/pages/duiba_v2/share/index?activityId=shanghaitanpuhui_choujiang&cid=1403&bind=true&hideShare=false')
    } else if (!rewardInfo?.openStatus) {
      // 未开通
      Dialog.confirm({
        content: <div className={styles['confirmdialog-content']}>
          <div>您还没有完成开通碳账户流程哦，</div>
          <div> 暂时没有奖励可以抽取</div>
        </div>,
        closeOnMaskClick: true,
        cancelText: <span className={styles['confirmdialog-cancelbtn']}>我再想想</span>,
        confirmText: <div element-id="去开通" element-content="随申行-去开通">去开通</div>,
        bodyClassName: styles.confirmdialog,
        onConfirm: () => {
          onJumpPath()
        }
      })
    } else {
      Toast.show({
        content: "仅限从绿喵开通个人碳账户的用户哦～",
      });
    }
  }, [rewardInfo, phoneNumber])

  return <div className={styles.wrap}>
    <Image className={styles.headerbg} src="https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/activites/suishenxing/activity_header.jpg" />
    <div className={styles.middle}>
      <Image className={styles['middle-bg']} src="https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/activites/suishenxing/activity_middle.jpg" />
      <div className={styles['middle-content']}>
        <Button block shape='rounded' className={styles["middle-content-primarybtn"]} element-content={rewardInfo?.openStatus ? '已开通' : '去开通'} element-id="去开通" onClick={onJumpPath}>
          {rewardInfo?.openStatus ? '已开通' : '去开通'}
        </Button>
        <Button block shape='rounded' className={styles["middle-content-cancelbtn"]} element-id="去领奖" element-content="随申行-去领奖" onClick={onPrize}>
          去领奖
        </Button>
      </div>
    </div>
    <Image className={styles.footerbg} src="https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/activites/suishenxing/activity_bottom.jpg" />
    <SafeArea position='bottom' />
  </div>
}
export default Guide
